// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".headers[data-v-9b630720]{display:grid;grid-template-columns:5fr repeat(4,1fr) 16px;grid-gap:16px;font-family:Roboto Mono,monospace;font-size:12px;text-align:right;margin-bottom:16px}.headers .size-field[data-v-9b630720]:first-letter{text-transform:uppercase}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
